<script>
import ProcessStatusView, { ProcessStatus } from "@/components/ProcessStatusView"
import QueryRunner from "@/services/ad-hoc-query-runner-2";
import flywhweelSFMCUtilFactory from "@/services/flywheel-sfmc-util";
import flywhweelDEUtilFactory from "@/services/flywheel-de-util";
import FolderSelector from "@/components/FolderSelector.vue";
import FormInputGroupView, { FormInputGroup } from '@/components/form-input-group2/FormInputGroup';
import dataExtensionRootFoldersFactory from '@/services/data-extension-root-folders';

var formConfig = [
    {
        "key": "deTgtName",
        "label": "New Data Extension Name",
        "attrs": {
            "type": "text",
            "required": true,
            "maxlength": 96
        }
    },
    {
        "key": "retentionInDays",
        "label": "New Data Extension Retention in Days",
        "attrs": {
            "type": "text",
            "required": true,
            "pattern": "^[1-9][0-9]*$"
        }
    }
];


export default {
    name: "DataExtensionCopyView",
    components: {
        FolderSelector,
        ProcessStatusView,
        FormInputGroupView
    },
    beforeCreate: function() {
        this.$sfmcDE = flywhweelDEUtilFactory(this);
        this.$sfmcFolder = flywhweelSFMCUtilFactory(this, "folder");
        this.$dataExtensionRootFolders = dataExtensionRootFoldersFactory(this.$store, this.$sfmcFolder);
    },
    data: function() {
        var data = {
            uiStates: {
                LOADING: 'loading',
                SELECT_DE: 'select-de',
                CHECKING_SELECTED_DE: 'check-selected-de',
                RUNNING_QUERY: 'running-query',
                RUNNING_QUERY_ERROR: 'running-query-error',
                COMPLETE: 'complete'
            },
            processStates: {
                CREATING_DE: 'Copying data extension...',
                SAMPLES_COMPLETE: 'Copied data extension is ready.'
            },
            uiState: null,
            form: {
                inputs: FormInputGroup.makeInputs(formConfig),
                values: FormInputGroup.makeValues(formConfig, {
                    deTgtName: QueryRunner.makeId('COPY'),
                    retentionInDays: '21'
                })
            },
            rootFolders: [],
            rootFolder: null,
            rootFolderSelectorDisabled: true,
            
            dataExtensionSrc: null,
            dataExtensionTgtParams: null,

            dataExtensionTgtName: '',
            dataExtensionTgtPath: '',

            processStatus: new ProcessStatus(QueryRunner.STATE_IDLE),

            QueryRunner
        };

        //data.uiState = data.uiStates.CONFIGURE_COUNTS;
        data.uiState = data.uiStates.LOADING;

        data.rootFolder = data.rootFolders[0];
        
        return data;
    },
    created: function() {
        this.formInputs = FormInputGroup.util(() => this.form.inputs);
    },
    mounted: function() {
        this.$dataExtensionRootFolders.getFoldersAvailable().then(
            (foldersAvailable) => {
                this.rootFolders = foldersAvailable;
            }
        );
    },
    computed: {
        queryRunnerDisabled: function() {
            return (
                (this.processStatus.state != QueryRunner.STATE_IDLE) &&
                (this.processStatus.state != QueryRunner.STATE_ERROR)
            );
        }
    },
    watch: {
        uiState: function(value) {
            var disabled = value != this.uiStates.SELECT_DE;
            this.formInputs.forEach((input) =>  {
                input.attrs.disabled = disabled;
            });
        },
        'rootFolders': function() {
            if (this.uiState == this.uiStates.LOADING) {
                if (this.rootFolders.length) {
                    this.rootFolder = this.rootFolders[0];
                    this.uiState = this.uiStates.SELECT_DE;
                }
            }
        }
    },
    methods: {
        setDeTgtName: function() {
            this.form.values.deTgtName = QueryRunner.makeId(
                'COPY',
                (this.dataExtensionSrc && this.dataExtensionSrc.Name) ?
                this.dataExtensionSrc.Name :
                ''
            );
        },

        backToSelectDataExtension: function() {
            this.dataExtensionTgtParams = null;
            this.dataExtensionSrc = null;
            this.uiState = this.uiStates.SELECT_DE;
        },
        folderSelectorState: function(state) {
            if ((state == 'unk') || (state == 'loading')) {
                this.rootFolderSelectorDisabled = true;
            } else {
                this.rootFolderSelectorDisabled = false;
            }
        },
        
        formChangeConfig: function(event) {
            this.form.values[event.key] = event.value;
        },

        prepDETgtParams: function(data) {
            var params = {
                name: this.form.values.deTgtName
            };
            return this.$sfmcDE.prepDEPropertiesForCreate(data).then(
                (response) => {
                    params.properties = response.properties;
                    params.fieldMap = response.fieldMap;
                    
                    return this.$sfmcFolder.apiCall(
                        'retrieve_path_from_id',
                        {
                            id: this.dataExtensionSrc.CategoryID
                        }
                    );
                }
            ).then(
                (response) => {
                    params.path = response.data;
                    return Promise.resolve(params);
                }
            );
        },
        deSelected: function(objectType, object, folder) {
            this.uiState = this.uiStates.CHECKING_SELECTED_DE;
            this.$sfmcDE.apiCall(
                "retrieve",
                {
                    "complex_filter": this.$sfmcDE.complexFilter(
                        this.$sfmcDE.simpleFilter(
                            'CustomerKey',
                            object.CustomerKey
                        ),
                        'AND',
                        this.$sfmcDE.simpleFilter(
                            'CategoryID',
                            folder.ID
                        )
                    ),
                    "get_columns": true,
                    "single_result": true,
                    "query_all_accounts": true
                }
            ).then(
                (response) => {
                    this.dataExtensionSrc = JSON.parse(JSON.stringify(response.data));
                    this.setDeTgtName();
                    return this.prepDETgtParams(response.data);
                }
            ).then(
                (params) => {
                    this.dataExtensionTgtParams = params;
                    this.uiState = this.uiStates.SELECT_DE;
                }
            );
        },
        copyDataExtension: function() {
            this.processStatus.reset();
            this.processStatus.state = this.processStates.CREATING_DE;
            this.uiState = this.uiStates.RUNNING_QUERY

            var properties = this.$sfmcDE.setDataRetentionToProperties(
                this.dataExtensionTgtParams.properties,
                {
                    DataRetentionPeriod: "Days",
                    DataRetentionPeriodLength: String(this.form.values.retentionInDays),
                    DeleteAtEndOfRetentionPeriod: "false"
                }
            );
            return this.$sfmcDE.copy(
                (
                    ((this.rootFolder.ent && this.$store.getters.bu.isChild) ? 'ent.' : '') +
                    this.dataExtensionSrc.Name
                ),
                properties,
                this.dataExtensionTgtParams.fieldMap,
                this.form.values.deTgtName,
                (
                    this.rootFolder.canCreateDE ?
                    this.dataExtensionTgtParams.path :
                    QueryRunner.tgtDEPathDefault
                ),
                this.processStatus
            ).then(
                (queryRunner) => {
                    this.dataExtensionTgtName = queryRunner.options.tgtDEName;
                    this.dataExtensionTgtPath = queryRunner.options.tgtDEPath;
                    this.uiState = this.uiStates.COMPLETE;
                },
                () => {
                    this.uiState = this.uiStates.RUNNING_QUERY_ERROR;
                }
            );
        }
    }
}
</script>

<template src="./DataExtensionCopy.html"></template>

<style lang="scss" src="./DataExtensionCopy.scss"></style>